import { instance } from '.';


export const renombrarCarpeta = async (path, oldName, newName) => {

    const encodedPath = path ? encodeURI(path) : "root";  // Usamos "root" como valor especial si el path está vacío
    const resp = await instance.post(`/fileupload/ChangeFolderName/${encodedPath}/${encodeURI(oldName)}/${encodeURI(newName)}`);
    return resp;
}

export const crearCarpeta = async (path, folderName) => {
    const resp = await instance.post(`/fileupload/CreateNewFolder/${encodeURI(path)}/${folderName}`);
    return resp;
}

export const borrarCarpeta = async (path) => {

    const resp = await instance.post(`/fileupload/DeleteFolder/${encodeURI(path)}`);
    return resp;
}

export const subirFichero = async (path, fileName, file) => {
    const formData = new FormData();

    formData.append('file', file);
    const resp = await instance.post(`/fileupload/UploadFile/${encodeURI(path)}/${fileName}`, formData);
    return resp;
}

export const borrarArchivo = async (path, fileName) => {

    const resp = await instance.post(`/fileupload/DeleteFile/${encodeURI(path)}/${fileName}`);
    return resp;
}

export const duplicarDocumentosOferta = async ( oldOffer, newOffer, nombreCliente, codigoCliente) => {
    try {
        // Limpiamos tabuladores, saltos de línea y espacios sobrantes que vienen
        // pegados al nombre del cliente. Como carácter de control en la ruta,
        // el tabulador (%09) hace que IIS/Kestrel rechacen la petición con 400
        // antes del middleware CORS, lo que se reporta como falso error de CORS.
        const nombreLimpio = nombreCliente
            .replace(/[\t\r\n]+/g, ' ')
            .replace(/\s+/g, ' ')
            .trim();
        const clienteEscaped = encodeURIComponent(nombreLimpio);

        const resp = await instance.post(
            `/fileupload/CloneOfferFolders/${oldOffer}/${newOffer}/${clienteEscaped}/${codigoCliente}`
        );

        return resp.data;
    } catch (error) {
        console.error("Error al duplicar documentos:", error);
        throw error;
    }
};



